import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchCuratedCollectionData, getCuratedCollectionItemIds } from '@/redux/modules/curatedCollection';
import { fetchItemCardModelsIfNeeded } from '@/redux/modules/itemCardModel';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch, getState } = store;

    return Promise.all([dispatch(fetchCuratedCollectionData(Number(params.collectionId)))]).then(() => {
        const currentState = getState();
        const itemIds = getCuratedCollectionItemIds(currentState);
        return dispatch(fetchItemCardModelsIfNeeded(itemIds, 'CURATED-COLLECTION-PAGE-LOADER'));
    });
};
